import { toast } from 'sonner';

/**
 * Available notification types.
 * @readonly
 * @enum {string}
 */
export const NotificationType = {
  DEFAULT: 'DEFAULT',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
};

/**
 * Returns the icon classNames.
 *
 * @param {NotificationType} notificationType - The type/style of the notification.
 *
 * @returns {string}
 */
const iconClassNames = notificationType => {
  switch (notificationType) {
    case NotificationType.INFO:
      return 'theme-color--blue';

    case NotificationType.SUCCESS:
      return 'theme-color--green';

    case NotificationType.WARNING:
      return 'theme-color--yellow';

    case NotificationType.ERROR:
      return 'theme-color--red';

    default:
      return '';
  }
};

/**
 * Sends a UI toast notification.
 *
 * @param {Object} params - Notification parameters.
 * @param {string} params.id - The toast ID.
 * @param {string} params.title - The title displayed in the notification.
 * @param {string} [params.description] - Optional descriptive text displayed below the title.
 * @param {number} [params.duration] - Duration (in milliseconds) before the notification disappears.
 * @param {NotificationType} [params.type=NotificationType.DEFAULT] - The type/style of the notification.
 *
 * @returns {void}
 */
export const sendNotification = ({
  id,
  title,
  description,
  duration = 8000,
  type: notificationType = NotificationType.DEFAULT,
  action,
}) => {
  if (notificationType === NotificationType.DEFAULT) {
    toast(title, {
      id,
      description,
      duration,
      dismissible: true,
      closeButton: true,
      action,
      style: { background: 'red' },
    });
  } else if (notificationType in toast) {
    toast[notificationType](title, {
      id,
      description,
      duration,
      classNames: { icon: iconClassNames(notificationType) },
      dismissible: true,
      closeButton: true,
      action,
      actionButtonStyle: {},
    });
  }
};
